import { FunctionComponent } from 'react'
import { ApiComponents } from '@black-bear-energy/black-bear-energy-common'
import { Avatar, Box, IconButton, Tooltip } from '@black-bear-energy/rucksack'
import { Field } from 'components/DocumentExchange/Field'
import { MailOutlineRounded } from '@mui/icons-material'

type UserDetails = ApiComponents['schemas']['UserDetails']

export const UserContact: FunctionComponent<UserContactProps> = ({
  role,
  user,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '8px',
        '& .MuiTypography-body1': { fontSize: '12px' },
      }}
    >
      <Avatar>{user ? getUserAvatar(user) : '—'}</Avatar>
      <Box sx={{ flex: '1 0 0' }}>
        <Field label={user ? getUserName(user) : '—'}>{role}</Field>
      </Box>
      <Tooltip title="Send Email">
        <span>
          <IconButton
            href={user ? `mailto:${user.email}` : ''}
            disabled={!user}
          >
            <MailOutlineRounded />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

function getUserAvatar(user: UserDetails): string {
  const firstName = user.firstName
  const lastName = user.lastName
  if (firstName || lastName) {
    return `${firstName ? firstName[0] : ''}${
      lastName ? lastName[0] : ''
    }`.toUpperCase()
  }

  return user.email[0].toUpperCase()
}

function getUserName(user: UserDetails): string {
  const firstName = user.firstName
  const lastName = user.lastName
  if (firstName || lastName) {
    return [firstName, lastName].filter((name) => name != null).join(' ')
  }

  return user.email
}

export interface UserContactProps {
  role: string
  user?: UserDetails
}
